<template>
  <Layout>
    <div class="row justify-content-center">
      <b-card no-body class="overflow-hidden" style="max-width: 540px;">
        <b-row no-gutters>
          <b-col md="4" class="text-center">
            <b-card-img :src="require('@/assets/images/icon_shield.png')" alt="Image" class="rounded-0 logo-shield mt-5"></b-card-img>
            <div class="manual-guide">
              <a href="https://ofm-cdn0.ofm.co.th/documents/UserGuide-2FA-OASYSX-10112021.pdf" target="_blank">แนะนำการใช้งาน</a>
            </div>
          </b-col>
          <b-col md="8">
            <b-card-body title="Scan QR Code">
              <b-card-text class="text-center">
                  <img :src="qrCodeSrc" width="200" v-if="qrCodeSrc !== ''"/>
                  <div class="mb-2">
                    <span class="" v-if="isVerifyCodeExpire">Verify Code หมดอายุ</span>
                  </div>
                  <div class="text-center" v-if="callbackUrl !== ''">
                    <b-button class="btn btn-on btn-default fs-18 fw-light w-100" @click="onClick()"
                    style="max-width: 200px">กลับ</b-button>
                  </div>
              </b-card-text>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <modal-warning :title="modalWarning.title" :show="modalWarning.display"  :warningMessages="warningMessages"
      @hidden="modalWarning.display = false"></modal-warning>
  </Layout>
</template>
<script>
import modalWarning from '@/components/shared/modal-warning.vue'
import Layout from "../../layouts/two-factor";
import axios from 'axios'
import { isValid } from "@/helpers/utils/utils.js";
import { eventBus } from '@/main.js'
export default {
  components: {
    Layout,
    'modal-warning': modalWarning,
  },
  data () {
    return {
      modalWarning: {
        display: false,
        title: ''
      },
      warningMessages: [],
      verifyCode: '',
      qrCodeSrc: '',
      callbackUrl: '',
      isVerifyCodeExpire: false
    }
  },
  mounted() {
    if (this.$route.query !== undefined && this.$route.query !== null) {
      if (isValid(this.$route.query.verifyCode)) {
        this.getQRCode(this.$route.query.verifyCode)
      } else {
        this.toggleWarningModal('verifyCode not found')
      }
      if (isValid(this.$route.query.callbackUrl)) this.callbackUrl = atob(this.$route.query.callbackUrl)
    } else {
      this.toggleWarningModal('verifyCode not found')
    }
  },
  methods: {
    getQRCode(verifyCode) {
      eventBus.$emit('changeLoadingState', true)
      const params = new URLSearchParams()
      params.append('apikey', process.env.VUE_APP_BASE_TWO_FACTOR_KEY)
      params.append('token', verifyCode)
      if (process.env.NODE_ENV === 'develop' || process.env.NODE_ENV === 'local')
        params.append('issuer', 'dev-officemate')
      axios({
          method: 'GET',
          baseURL: process.env.VUE_APP_BASE_TWO_FACTOR_API,
          headers: {
            'Content-Type': 'application/json'
          },
          url: `users/me/secret`,
          params: params
        }).then((result) => {
          console.log('result', result)
          this.qrCodeSrc = result.data.imagesQrCodeSetupImageUrl
        }).catch(error => {
          console.log(error.response)
          if (error.response.data.errors.find(q => q.message === 'This verify code has expired.') !== undefined) {
            this.toggleWarningModal('Verify Code หมดอายุ')
            this.isVerifyCodeExpire = true
          } else {
            this.toggleWarningModal('เกิดข้อผิดพลาด')
          }
        }).finally(() => {
          eventBus.$emit('changeLoadingState', false)
        })
    },
    onCloseModal() {
      this.modalWarning.display = false
      //TODO
    },
    toggleWarningModal(msg) {
      this.warningMessages = []
      this.warningMessages.push(msg)
      this.modalWarning.display = true
    },
    onClick() {
      this.$router.push(this.callbackUrl)
    }
  }
}
</script>
<style>
.card {
  border: 5px solid rgba(0, 0, 0, 0.125);
  border-radius: 1.25rem;
}

.blank-page {
  margin-top: 74px;
  /* margin-bottom: 30px; */
  /* height: 720px; */
  height: calc(100vh - 190px);
  min-height: 300px;
  display: flex;
}
.blank-page > div {
  justify-content: center;
  align-items: center;
  display: flex;
}

.manual-guide {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-decoration: underline!important;
  font-size: 14px;
}

.manual-guide > a{
  cursor: pointer;
  color: #6e6e6e!important;
}

@media screen and (max-width: 1024px) {
    .nav-blank {
    padding: 20px 1rem
    }
    .blank-page {
        max-height: calc(100vh - 90px);
        height: calc(100vh - 190px);
    }
}

/* responsive */
@media screen and (max-width: 600px) {
  .blank-page > .container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .blank-page {
    height: calc(100vh - 175px)!important;
  }
}

@media screen and (max-width: 600px) {
  body {
  min-height: 100%!important;
}
  .logo-shield {
    max-width: 160px;
  }

  .manual-guide {
    left: 32%!important;
  }
}
</style>